import(/* webpackMode: "eager" */ "/vercel/path0/app/forgot/page.tsx");
